// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import {
//   Code,
//   ShoppingCart,
//   Settings,
//   Megaphone,
//   Cloud,
//   Laptop,
//   Camera,
//   Printer,
//   Wrench,
//   GraduationCap,
// } from "lucide-react";

// export default function InfronexOnePage() {
//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true });
//   }, []);

//   const softwareServices = [
//     {
//       icon: <Code className="w-10 h-10 animate-bounce" />,
//       title: "Web & Mobile App Development",
//       desc: "Crafting responsive, fast, and modern applications that elevate your business online.",
//       bg: "from-indigo-50 to-indigo-100",
//       hover: "hover:from-indigo-200 hover:to-indigo-50",
//     },
//     {
//       icon: <ShoppingCart className="w-10 h-10 animate-bounce" />,
//       title: "E-Commerce Platforms & Integrations",
//       desc: "Build seamless online stores with advanced analytics and payment integrations.",
//       bg: "from-emerald-50 to-emerald-100",
//       hover: "hover:from-emerald-200 hover:to-emerald-50",
//     },
//     {
//       icon: <Settings className="w-10 h-10 animate-bounce" />,
//       title: "ERP / CRM / HRM Implementation",
//       desc: "Streamlining operations and improving workflow efficiency through smart automation.",
//       bg: "from-purple-50 to-purple-100",
//       hover: "hover:from-purple-200 hover:to-purple-50",
//     },
//     {
//       icon: <Megaphone className="w-10 h-10 animate-bounce" />,
//       title: "Digital Marketing & SEO",
//       desc: "Data-driven digital strategies to boost visibility and customer engagement.",
//       bg: "from-pink-50 to-pink-100",
//       hover: "hover:from-pink-200 hover:to-pink-50",
//     },
//     {
//       icon: <Cloud className="w-10 h-10 animate-bounce" />,
//       title: "Cloud Computing & DevOps",
//       desc: "Optimized cloud infrastructure and CI/CD deployment for businesses of any scale.",
//       bg: "from-cyan-50 to-cyan-100",
//       hover: "hover:from-cyan-200 hover:to-cyan-50",
//     },
//   ];

//   const hardwareServices = [
//     {
//       icon: <Laptop className="w-10 h-10 animate-bounce" />,
//       title: "Laptop & Desktop Sales & Service",
//       desc: "Authorized sales and repairs with trusted hardware support and maintenance.",
//       bg: "from-indigo-50 to-indigo-100",
//       hover: "hover:from-indigo-200 hover:to-indigo-50",
//     },
//     {
//       icon: <Camera className="w-10 h-10 animate-bounce" />,
//       title: "CCTV & Security Systems",
//       desc: "High-definition surveillance setup with professional installation and maintenance.",
//       bg: "from-amber-50 to-amber-100",
//       hover: "hover:from-amber-200 hover:to-amber-50",
//     },
//     {
//       icon: <Printer className="w-10 h-10 animate-bounce" />,
//       title: "Printer & Accessories Solutions",
//       desc: "Comprehensive printing solutions for office and business environments.",
//       bg: "from-rose-50 to-rose-100",
//       hover: "hover:from-rose-200 hover:to-rose-50",
//     },
//     {
//       icon: <Wrench className="w-10 h-10 animate-bounce" />,
//       title: "Onsite / Remote Tech Support",
//       desc: "Instant troubleshooting and expert support at your convenience.",
//       bg: "from-teal-50 to-teal-100",
//       hover: "hover:from-teal-200 hover:to-teal-50",
//     },
//   ];

//   return (
//     <div className="bg-white text-gray-800 min-h-screen overflow-hidden">
//       {/* HERO SECTION (reduced height) */}
//       <section
//         className="relative h-[60vh] flex items-center justify-center text-center bg-gradient-to-r from-blue-600 via-purple-600 to-pink-500"
//         aria-label="Hero"
//       >
//         <div className="absolute inset-0 bg-black/28"></div> {/* overlay */}
//         <div className="relative z-10 px-6" data-aos="fade-up">
//           <h1 className="text-3xl md:text-5xl font-extrabold mb-4 bg-gradient-to-r from-yellow-300 via-white to-yellow-400 bg-clip-text text-transparent">
//             INFRONEX TECHNOLOGIES — IT PRODUCTS & SERVICE
//           </h1>
//           <p className="text-md md:text-xl max-w-3xl mx-auto text-white/90">
//             Leading Innovation in Software, Hardware, and Career Development
//           </p>
//         </div>
//       </section>

//       {/* SOFTWARE SERVICES */}
//       <section className="py-20 px-6 md:px-20 bg-white" data-aos="fade-up">
//         <h2 className="text-3xl font-bold mb-10 text-center text-blue-700">
//           💻 Our Software Services
//         </h2>
//         <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
//           {softwareServices.map((service, i) => (
//             <div
//               key={i}
//               className={`bg-gradient-to-br ${service.bg} border border-blue-100 p-8 rounded-2xl shadow-md transform transition-all duration-300 ${service.hover} hover:shadow-xl hover:-translate-y-2 text-center`}
//               data-aos="zoom-in"
//             >
//               <div className="flex justify-center mb-4">{service.icon}</div>
//               <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
//               <p className="text-gray-600">{service.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* HARDWARE SERVICES */}
//       <section className="py-20 px-6 md:px-20 bg-gray-50" data-aos="fade-up">
//         <h2 className="text-3xl font-bold mb-10 text-center text-green-700">
//           🔧 Our Hardware Solutions
//         </h2>
//         <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
//           {hardwareServices.map((service, i) => (
//             <div
//               key={i}
//               className={`bg-gradient-to-br ${service.bg} border border-green-100 p-8 rounded-2xl shadow-md transform transition-all duration-300 ${service.hover} hover:shadow-xl hover:-translate-y-2 text-center`}
//               data-aos="zoom-in"
//             >
//               <div className="flex justify-center mb-4">{service.icon}</div>
//               <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
//               <p className="text-gray-600">{service.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* INTERNSHIP SECTION */}
//       <section
//         className="py-20 px-6 md:px-20 text-center bg-white"
//         data-aos="fade-up"
//       >
//         <GraduationCap className="w-14 h-14 mx-auto mb-4 text-blue-600" />
//         <h2 className="text-3xl font-bold mb-4 text-gray-800">
//           🎓 Internship Opportunities
//         </h2>
//         <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
//           Step into the real tech world with Infronex’s internship programs in{" "}
//           <strong>Web Development, Cloud, Networking, and IT Support</strong>.
//           Learn directly from industry professionals and build your portfolio
//           with live projects.
//         </p>
//       </section>

//       {/* CONTACT SECTION (replaces Partnered Institutes & Footer) */}
//       <section
//         className="py-16 px-6 md:px-20 bg-gradient-to-r from-neutral-50 to-neutral-100 text-center"
//         data-aos="fade-up"
//       >
//         <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800">
//           📞 Contact Us
//         </h2>
//         <p className="mb-6 text-gray-600">
//           For inquiries, partnerships, or support — reach out to us.
//         </p>

//         <div className="max-w-xl mx-auto grid gap-4 text-left">
//           <div className="flex items-center justify-between bg-white p-4 rounded-xl shadow-sm">
//             <div>
//               <div className="text-sm text-gray-500">Phone</div>
//               <div className="text-lg font-semibold">
//                 <a href="tel:+918248387513" className="hover:underline">
//                   +91 82483 87513
//                 </a>
//                 {"  /  "}
//                 <a href="tel:+919488611321" className="hover:underline">
//                   +91 94886 11321
//                 </a>
//               </div>
//             </div>
//           </div>

//           <div className="flex items-center justify-between bg-white p-4 rounded-xl shadow-sm">
//             <div>
//               <div className="text-sm text-gray-500">Email</div>
//               <div className="text-lg font-semibold">
//                 <a href="mailto:infronex@gmail.com" className="hover:underline">
//                   infronex@gmail.com
//                 </a>
//                 {"  /  "}
//                 <a href="mailto:info@infronex.com" className="hover:underline">
//                   info@infronex.com
//                 </a>
//               </div>
//             </div>
//           </div>

//           <div className="text-sm text-gray-500 text-center">
//             © {new Date().getFullYear()} Infronex Technologies — Innovate |
//             Build | Grow
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Code,
  ShoppingCart,
  Settings,
  Megaphone,
  Cloud,
  Laptop,
  Camera,
  Printer,
  Wrench,
  GraduationCap,
} from "lucide-react";

export default function InfronexOnePage() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const softwareServices = [
    {
      icon: <Code className="w-10 h-10 animate-bounce" />,
      title: "Web & Mobile App Development",
      desc: "Crafting responsive, fast, and modern applications that elevate your business online.",
      bg: "from-indigo-50 to-indigo-100",
      hover: "hover:from-indigo-200 hover:to-indigo-50",
    },
    {
      icon: <ShoppingCart className="w-10 h-10 animate-bounce" />,
      title: "E-Commerce Platforms & Integrations",
      desc: "Build seamless online stores with advanced analytics and payment integrations.",
      bg: "from-emerald-50 to-emerald-100",
      hover: "hover:from-emerald-200 hover:to-emerald-50",
    },
    {
      icon: <Settings className="w-10 h-10 animate-bounce" />,
      title: "ERP / CRM / HRM Implementation",
      desc: "Streamlining operations and improving workflow efficiency through smart automation.",
      bg: "from-purple-50 to-purple-100",
      hover: "hover:from-purple-200 hover:to-purple-50",
    },
    {
      icon: <Megaphone className="w-10 h-10 animate-bounce" />,
      title: "Digital Marketing & SEO",
      desc: "Data-driven digital strategies to boost visibility and customer engagement.",
      bg: "from-pink-50 to-pink-100",
      hover: "hover:from-pink-200 hover:to-pink-50",
    },
    {
      icon: <Cloud className="w-10 h-10 animate-bounce" />,
      title: "Cloud Computing & DevOps",
      desc: "Optimized cloud infrastructure and CI/CD deployment for businesses of any scale.",
      bg: "from-cyan-50 to-cyan-100",
      hover: "hover:from-cyan-200 hover:to-cyan-50",
    },
  ];

  const hardwareServices = [
    {
      icon: <Laptop className="w-10 h-10 animate-bounce" />,
      title: "Laptop & Desktop Sales & Service",
      desc: "Authorized sales and repairs with trusted hardware support and maintenance.",
      bg: "from-indigo-50 to-indigo-100",
      hover: "hover:from-indigo-200 hover:to-indigo-50",
    },
    {
      icon: <Camera className="w-10 h-10 animate-bounce" />,
      title: "CCTV & Security Systems",
      desc: "High-definition surveillance setup with professional installation and maintenance.",
      bg: "from-amber-50 to-amber-100",
      hover: "hover:from-amber-200 hover:to-amber-50",
    },
    {
      icon: <Printer className="w-10 h-10 animate-bounce" />,
      title: "Printer & Accessories Solutions",
      desc: "Comprehensive printing solutions for office and business environments.",
      bg: "from-rose-50 to-rose-100",
      hover: "hover:from-rose-200 hover:to-rose-50",
    },
    {
      icon: <Wrench className="w-10 h-10 animate-bounce" />,
      title: "Onsite / Remote Tech Support",
      desc: "Instant troubleshooting, expert support, and Annual Maintenance Contracts (AMC) for offices and homes — ensuring your systems run smoothly all year round.",
      bg: "from-teal-50 to-teal-100",
      hover: "hover:from-teal-200 hover:to-teal-50",
    },
  ];

  // Shared color palette for gradient corners
  const featureColors = [
    "#4f46e5", // Indigo
    "#10b981", // Emerald
    "#9333ea", // Purple
    "#ec4899", // Pink
    "#06b6d4", // Cyan
    "#f59e0b", // Amber
  ];

  return (
    <div className="bg-white text-gray-800 min-h-screen overflow-hidden">
      {/* HERO SECTION */}
      <section
        className="relative h-[60vh] flex items-center justify-center text-center bg-gradient-to-r from-blue-600 via-purple-600 to-pink-500"
        aria-label="Hero"
      >
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="relative z-10 px-6" data-aos="fade-up">
          <h1 className="text-3xl md:text-5xl font-extrabold mb-4 bg-gradient-to-r from-yellow-300 via-white to-yellow-400 bg-clip-text text-transparent">
            INFRONEX IT PRODUCTS & SERVICES
          </h1>
          <p className="text-md md:text-xl max-w-3xl mx-auto text-white/90">
            Leading Innovation in Software, Hardware, and Career Development
          </p>
        </div>
      </section>

      {/* SOFTWARE SERVICES */}
      <section className="py-20 px-6 md:px-20 bg-white" data-aos="fade-up">
        <h2 className="text-3xl font-bold mb-10 text-center text-blue-700">
          💻 Our Software Services
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {softwareServices.map((service, i) => {
            const color = featureColors[i % featureColors.length];
            return (
              <div
                key={i}
                className={`relative p-8 bg-gradient-to-br ${service.bg} border border-blue-100 rounded-2xl shadow-md transform transition-all duration-500 ${service.hover} hover:shadow-2xl hover:scale-105 hover:rotate-1 shake-hover`}
                data-aos="zoom-in"
                data-aos-delay={i * 100}
              >
                {/* Gradient corner (top-left) */}
                <div
                  className="absolute top-0 left-0 w-12 h-12 rounded-tl-2xl pointer-events-none"
                  style={{
                    background: `linear-gradient(135deg, ${color}, transparent)`,
                    boxShadow: `0 0 10px ${color}`,
                  }}
                ></div>

                <div className="pt-4 pl-4">
                  <div className="flex justify-center mb-4">{service.icon}</div>
                  <h3 className="text-xl font-semibold mb-2 text-center">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-center">{service.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* HARDWARE SERVICES */}
      <section className="py-20 px-6 md:px-20 bg-gray-50" data-aos="fade-up">
        <h2 className="text-3xl font-bold mb-10 text-center text-green-700">
          🔧 Our Hardware Solutions
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {hardwareServices.map((service, i) => {
            const color = featureColors[i % featureColors.length];
            return (
              <div
                key={i}
                className={`relative p-8 bg-gradient-to-br ${service.bg} border border-green-100 rounded-2xl shadow-md transform transition-all duration-500 ${service.hover} hover:shadow-2xl hover:scale-105 hover:rotate-1 shake-hover`}
                data-aos="zoom-in"
                data-aos-delay={i * 100}
              >
                {/* Gradient corner (top-left) */}
                <div
                  className="absolute top-0 left-0 w-12 h-12 rounded-tl-2xl pointer-events-none"
                  style={{
                    background: `linear-gradient(135deg, ${color}, transparent)`,
                    boxShadow: `0 0 10px ${color}`,
                  }}
                ></div>

                <div className="pt-4 pl-4">
                  <div className="flex justify-center mb-4">{service.icon}</div>
                  <h3 className="text-xl font-semibold mb-2 text-center">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-center">{service.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* INTERNSHIP SECTION */}
      {/* INTERNSHIP SECTION (card style with gradient and pulse icon) */}
      <section
        className="py-20 px-6 md:px-20 flex justify-center"
        data-aos="fade-up"
      >
        <div className="bg-gradient-to-br from-blue-50 via-indigo-100 to-purple-50 rounded-3xl shadow-xl p-10 md:p-16 max-w-4xl text-center transition-all duration-300 hover:shadow-2xl hover:-translate-y-2">
          <GraduationCap className="w-16 h-16 mx-auto mb-6 text-blue-600 animate-pulse" />
          <h2 className="text-3xl font-bold mb-4 text-gray-800">
            🎓 Internship Opportunities
          </h2>
          <p className="text-gray-700 max-w-3xl mx-auto leading-relaxed text-lg">
            Step into the real tech world with{" "}
            <strong>Infronex’s Internship Programs</strong> in{" "}
            <strong>Web Development, Cloud, Networking, and IT Support</strong>.
            Learn directly from industry professionals and build your portfolio
            through live, hands-on projects that prepare you for a successful
            tech career.
          </p>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section
        className="py-16 px-6 md:px-20 bg-gradient-to-r from-neutral-50 to-neutral-100 text-center"
        data-aos="fade-up"
      >
        <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800 animate-bounce">
          📞 Contact Us
        </h2>
        <p className="mb-6 text-gray-600">
          For inquiries, partnerships, or support — reach out to us.
        </p>

        <div className="max-w-xl mx-auto grid gap-4 text-left">
          <div className="flex items-center justify-between bg-white p-4 rounded-xl shadow-sm">
            <div>
              <div className="text-sm text-gray-500">Phone</div>
              <div className="text-lg font-semibold">
                <a href="tel:+918248387513" className="hover:underline">
                  +91 82483 87513
                </a>
                {" / "}
                <a href="tel:+919488611321" className="hover:underline">
                  +91 94886 11321
                </a>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between bg-white p-4 rounded-xl shadow-sm">
            <div>
              <div className="text-sm text-gray-500">Email</div>
              <div className="text-lg font-semibold">
                <a href="mailto:infronex@gmail.com" className="hover:underline">
                  infronex@gmail.com
                </a>
                {" / "}
                <a href="mailto:info@infronex.com" className="hover:underline">
                  info@infronex.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
